/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const getExperienceFields = (type) => {
    switch (type) {
        case 'product':
            return `
                experiment
                products {
                    partNumber
                    name
                    isPassportEligible
                    image {
                        name
                        path
                    }
                    seo {
                        url
                    }
                    skuPriceRange {
                        retail { value }
                        sale { value }
                    }
                    productSkus {
                        partNumber
                        name
                    }
                    productType
                    productDeliveryType
                }
                attributionToken
                experimentTracking
            `;
        case 'content':
            return `
                content
                experiment
                experimentTracking
            `;
        case 'experiment':
            return `
                experiment
                experimentTracking
            `;

        default:
            return `
                content
                experiment
                experimentTracking
            `;
    }
};

const findExperienceQuery = (type, queryName = 'pzExperienceQuery') => {
    const fields = getExperienceFields(type);

    return gql`
    query ${queryName} (
      $brand: String!
      $environment: String!
      $user: UserSF!
      $targeting: TargetingSF!
      $userAttributes: [UserAttributesSF]
      $resolveIdentity: Boolean!
    ) {
      experience(
        brand: $brand
        environment: $environment
        user: $user
        targeting: $targeting
        userAttributes: $userAttributes
        resolveIdentity: $resolveIdentity
      ) {
        ${fields}
      }
    }
  `;
};

export default findExperienceQuery;
